import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

export const AdminRoleStr: string = 'Admin';
export const CompanyRoleStr: string = 'LegalEntity';
export const IndividualRoleStr: string = 'Individual';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  profileImage: string | undefined = undefined;

  constructor(private _authService: AuthService) {}

  get getUserData(): {
    id: string;
    email: string;
    fullName: string;
    companyName: string;
    role: string;
    friendlyRoles: string | string[];
  } {
    const decodedJWT = this._authService.getDecodedToken;
    this.profileImage =
      decodedJWT?.image_url?.length > 0 ? decodedJWT?.image_url : '';
    return {
      id: decodedJWT?.[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
      ],
      email:
        decodedJWT?.[
          'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
        ],
      fullName: decodedJWT?.fullName,
      companyName: decodedJWT?.companyName,
      role:
        decodedJWT?.[
          'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
        ],
      friendlyRoles: decodedJWT?.['friendlyRoles'],
    };
  }

  get getFriendlyRoles(): string {
    return this.getUserData.friendlyRoles as string;
  }

  isAdmin(): boolean {
    return this.getUserData.role === AdminRoleStr;
  }

  isCompany(): boolean {
    return this.getUserData.role === CompanyRoleStr;
  }

  isIndividual(): boolean {
    return this.getUserData.role === IndividualRoleStr;
  }

  getRoleRoutePrefix(...validRoles: string[]) {
    if (this.isAdmin() && validRoles.includes(AdminRoleStr)) {
      return 'admin';
    }
    if (this.isCompany() && validRoles.includes(CompanyRoleStr)) {
      return 'company';
    }
    if (this.isIndividual() && validRoles.includes(IndividualRoleStr)) {
      return 'individual';
    }
    console.log('error');
    return 'common';
  }

  getImageUrl() {
    return this.profileImage;
  }

  clearImageUrl() {
    this.profileImage = undefined;
  }
}
